define('dcf-tabs',["exports", "./dcf-utility"], function (_exports, _dcfUtility) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.DCFTabs = void 0;
  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
  var DCFTabs = /*#__PURE__*/function () {
    /**
     * Sets up events to be used and reconfigures tabGroups input to correct form
     * @constructor
     * @param {HTMLCollectionOf<HTMLElement> | HTMLElement[] | HTMLElement } tabGroups - Array, Collection, or single tab group element
     * @param { Object } options - Unused
     * @returns { void }
     */
    function DCFTabs(tabGroups) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, DCFTabs);
      // Sets up events for later use
      this.tabsReadyEvent = new Event(DCFTabs.events('tabsReady'));
      this.tabSwitchedEvent = new Event(DCFTabs.events('tabSwitched'));

      // Store the tabGroups inputted (always will be an array)
      this.tabGroups = tabGroups;
      if (NodeList.prototype.isPrototypeOf(this.tabGroups)) {
        this.tabGroups = Array.from(this.tabGroups);
      } else if (!Array.isArray(this.tabGroups)) {
        this.tabGroups = [this.tabGroups];
      }
    }

    /**
     * Validates and returns standardized name of events for tabs
     * @static
     * @param { string } name - Name of the event to be returned
     * @returns { string } Standard name of the event
     */
    _createClass(DCFTabs, [{
      key: "initialize",
      value:
      /**
       * Initialized tabGroups to the finalized components
       * - Validates and modifies HTML structure
       * - Getting classes added to specific elements
       * - Calls methods for getting event listeners set up
       * @returns { void }
       */
      function initialize() {
        var _this = this;
        // Loops through each tabGroup and sets it up
        this.tabGroups.forEach(function (tabGroup) {
          // Create a random ID for the tabGroup
          var uuid = _dcfUtility.DCFUtility.uuidv4();

          // Get the tablist and an array of the panels
          var tabList = tabGroup.querySelector('.dcf-tabs > ol, .dcf-tabs > ul');
          var panels = Array.from(tabGroup.querySelectorAll('.dcf-tabs > div:not(:empty), .dcf-tabs > section:not(:empty)'));

          // If the tabGroup has no ID then it will set it
          if (tabGroup.getAttribute('id') === null) {
            tabGroup.setAttribute('id', _dcfUtility.DCFUtility.checkSetElementId(tabGroup, uuid.concat('-tab-group')));
          }

          // TabGroup needs to have some panels for it to work
          if (panels.length === _dcfUtility.DCFUtility.magicNumbers('int0')) {
            throw new Error('No Panels Found', {
              cause: tabGroup
            });
          }

          // Every panel needs to have an ID set
          var panelsWithNoIds = panels.filter(function (panel) {
            return panel.getAttribute('id') === null;
          });
          if (panelsWithNoIds.length !== _dcfUtility.DCFUtility.magicNumbers('int0')) {
            throw new Error('Panels Missing Ids', {
              cause: panelsWithNoIds
            });
          }

          // If the tablist is not created it will loop through the panels and create one
          if (tabList === null) {
            tabList = document.createElement('ul');
            panels.forEach(function (singlePanel) {
              // Gets tab text from the panel title
              var tabTextElem = singlePanel.querySelector('.dcf-tabs-panel-title');
              var tabText = tabTextElem !== null ? tabTextElem.innerText : 'Untitled';
              var tabHidden = singlePanel.dataset.tabHidden === 'true';

              // Creates a new link element with the href pointing to panel
              var newTabLinkElem = document.createElement('button');
              newTabLinkElem.innerText = tabText;
              newTabLinkElem.setAttribute('href', "#".concat(singlePanel.id));
              if (tabHidden) {
                newTabLinkElem.setAttribute('hidden', '');
              }

              // Creates new link element and adds everything to appropriate place
              var newTabElem = document.createElement('li');
              newTabElem.append(newTabLinkElem);
              tabList.append(newTabElem);
            });

            // Adds new tablist to the tabGroup before any panels
            tabGroup.insertBefore(tabList, panels[_dcfUtility.DCFUtility.magicNumbers('int0')]);
          }

          // Adds classes to the tabList and sets role
          tabList.classList.add('dcf-tabs-list', 'dcf-list-bare', 'dcf-mb-0');
          tabList.setAttribute('role', 'tablist');

          // Add tab panel semantics and hide them all in each tab group.
          panels.forEach(function (panel) {
            // Sets up panel with role, tabindex, classes, and hides them
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('tabindex', '0');
            panel.classList.add('dcf-tabs-panel');
            panel.setAttribute('hidden', '');
          });

          // Tab styling and functions.
          var tabs = Array.from(tabList.querySelectorAll('a, button'));

          // Checks if there are any tabs not hidden, if not there will be an error
          var tabsNotHidden = tabs.filter(function (tab) {
            return tab.getAttribute('hidden') === null;
          });
          if (tabsNotHidden.length === _dcfUtility.DCFUtility.magicNumbers('int0')) {
            throw new Error('All Tabs Hidden');
          }

          // Loops through all the tabs and sets them up
          tabs.forEach(function (tab, tabIndex) {
            // Adds classes, roles, tabindex, and removed aria-selected
            tab.classList.add('dcf-tab', 'dcf-d-block');
            tab.setAttribute('role', 'tab');
            tab.setAttribute('tabindex', '-1');
            tab.removeAttribute('aria-selected');

            // Prefix each tab within its parent tab group with the corresponding uuid.
            var nextTab = tabIndex + _dcfUtility.DCFUtility.magicNumbers('int1');
            tab.setAttribute('id', _dcfUtility.DCFUtility.checkSetElementId(tab, uuid.concat('-tab-', nextTab)));

            // Add class and role to each tab's parent (list item)
            tab.parentNode.classList.add('dcf-tabs-list-item', 'dcf-mb-0');
            tab.parentNode.setAttribute('role', 'presentation');

            // If the href does not exist or it is not a fragment it will error
            if (tab.getAttribute('href') === null || tab.getAttribute('href') === '' || !tab.getAttribute('href').startsWith('#')) {
              throw new Error('Invalid Tab href', {
                cause: tab
              });
            }

            // Checks to see if the panel that matches that link exists
            var matchingPanel = document.getElementById(tab.getAttribute('href').replace('#', ''));
            if (matchingPanel === null) {
              throw new Error('Invalid Tab href reference', {
                cause: tab
              });
            }
            // Adds the final aria-labelledby to match the panel to the tab
            matchingPanel.setAttribute('aria-labelledby', tab.getAttribute('id'));

            // Sets up event listeners for the tab
            _this.setTabEventListeners(tab);
          });

          // SelectedTab is the final selected tab for the tabGroup
          // This will follow the priority list of
          // - 1. What ever is in the URL Fragment or Hash (Page will also auto scroll down to this one)
          // - 2. The first panel in the URL "Tabs" Param
          // - 3. The first panel with data-default attribute set to true
          // - 4. The first panel in the tabGroup
          var selectedTab = null;

          // Checks hash and it is set try setting it to the matching tab
          if (location.hash !== '') {
            selectedTab = tabGroup.querySelector(".dcf-tab[href=\"".concat(location.hash, "\"]:not([hidden])"));
          }

          // If the tab is still null then go to the next item on the list
          if (selectedTab === null) {
            var allNonHiddenTabs = Array.from(tabGroup.querySelectorAll('.dcf-tab:not([hidden])'));

            // Find the first panel that is in the URL
            allNonHiddenTabs.forEach(function (tab) {
              var matchingPanel = document.getElementById(tab.getAttribute('href').replace('#', ''));
              if (selectedTab === null && _this.checkPanelInURL(matchingPanel.getAttribute('id'))) {
                selectedTab = tab;
              }
            });

            // If the tab is still null then go to the next item on the list
            if (selectedTab === null) {
              // Find the first panel that has data-default as an attribute
              allNonHiddenTabs.forEach(function (tab) {
                var matchingPanel = document.getElementById(tab.getAttribute('href').replace('#', ''));
                if (selectedTab === null && 'default' in matchingPanel.dataset && matchingPanel.dataset.default === 'true') {
                  selectedTab = tab;
                }
              });

              // If the tab is still null then just use the first non-hidden tab
              if (selectedTab === null) {
                selectedTab = allNonHiddenTabs[_dcfUtility.DCFUtility.magicNumbers('int0')];
              }
            }
          }
          // Once we are here we should have a selected tab and we can switch to it
          _this.switchTab(selectedTab, false);

          // We can then set up the tabGroup event listeners and dispatch the even that the tabs are ready
          _this.setTabGroupEventListeners(tabGroup);
          tabGroup.dispatchEvent(_this.tabsReadyEvent);
        });
        this.scrollToHash();

        // We can set up an event listener on the window for when the hash changes to a tab
        window.addEventListener('hashchange', function () {
          // If the hash is an dcf-tab then we can switch to the tab and scroll down to it
          var tab = document.querySelector(".dcf-tab[href=\"".concat(location.hash));
          if (tab === null) {
            return;
          }
          _this.switchTab(tab);
          _this.scrollToHash();
        });
      }
    }, {
      key: "scrollToHash",
      value: function scrollToHash() {
        // If the hash is an dcf-tab then we can switch to the tab and scroll down to it
        var tab = document.querySelector(".dcf-tab[href=\"".concat(location.hash));
        if (tab === null) {
          return;
        }
        document.getElementById(location.hash.replace('#', '')).scrollIntoView();
      }

      /**
       * Parses url and determines if the panel id is in it
       * @param { string } panelID - Id of the panel element to check
       * @returns { bool }
       */
    }, {
      key: "checkPanelInURL",
      value: function checkPanelInURL(panelID) {
        var url = new URL(location.href);
        var tabsParam = url.searchParams.get('tabs');
        if (tabsParam === null) {
          return false;
        }
        return tabsParam.split(' ').includes(panelID);
      }

      /**
       * Parses url and modifies the hash value in it
       * @param { HTMLElement } tabGroup - TabGroup to pull new hash from
       * @returns { void }
       */
    }, {
      key: "updateURLHash",
      value: function updateURLHash(tabGroup) {
        var url = new URL(location.href);
        var panel = tabGroup.querySelector('.dcf-tabs-panel:not([hidden])');
        if (panel === null) {
          throw new Error('Invalid tabGroup');
        }
        url.hash = panel.getAttribute('id');
        history.replaceState('', '', url.toString());
      }

      /**
       * Parses url and removes any non-selected tabs from that tabGroup and adds any selected tabs
       * @param { HTMLElement } tabGroup - TabGroup to pull selected tab from
       * @returns { void }
       */
    }, {
      key: "updateURLParam",
      value: function updateURLParam(tabGroup) {
        var url = new URL(location.href);
        var tabsParam = url.searchParams.get('tabs');

        // Get the selected panel
        var panel = tabGroup.querySelector('.dcf-tabs-panel:not([hidden])');
        if (panel === null) {
          throw new Error('Invalid tabGroup');
        }

        // If there is nothing in the url for tabs we can just add the panel id
        if (tabsParam === null) {
          url.searchParams.set('tabs', panel.getAttribute('id'));

          // We want replace state here to not fill up the users history with weird tabs stuff
          history.replaceState('', '', url.toString());
          return;
        }

        // We can filter out any panels that are in the tabGroup then add the selected panel
        var panelList = tabsParam.split(' ');
        var newPanelList = panelList.filter(function (panelToCheck) {
          return tabGroup.querySelector("#".concat(panelToCheck)) === null;
        });
        newPanelList.push(panel.getAttribute('id'));

        // We want replace state here to not fill up the users history with weird tabs stuff
        url.searchParams.set('tabs', newPanelList.join(' '));
        history.replaceState('', '', url.toString());
      }

      /**
       * Sets up event listeners on tab group
       * - commandPrev to go to previous tab
       * - commandNext to go to next tab
       * - commandHome to go to first tab
       * - commandEnd to go to last tab
       *
       * @param {HTMLElement} tabGroup - TabGroup to set event listeners on
       * @returns { void }
       */
    }, {
      key: "setTabGroupEventListeners",
      value: function setTabGroupEventListeners(tabGroup) {
        var _this2 = this;
        tabGroup.addEventListener(DCFTabs.events('commandPrev'), function () {
          _this2.switchToPreviousTab(tabGroup);
        }, true);
        tabGroup.addEventListener(DCFTabs.events('commandNext'), function () {
          _this2.switchToNextTab(tabGroup);
        }, true);
        tabGroup.addEventListener(DCFTabs.events('commandHome'), function () {
          _this2.switchToFirstTab(tabGroup);
        }, true);
        tabGroup.addEventListener(DCFTabs.events('commandEnd'), function () {
          _this2.switchToEndTab(tabGroup);
        }, true);
      }

      /**
       * Set event listeners on inputted tab element
       * - Left Arrow for previous tab
       * - Right Arrow for next tab
       * - Home for first tab
       * - End for last tab
       * - Click to switch to the inputted tab
       * - commandSwitch to switch to the inputted tab
       *
       * @param {HTMLElement} tab - Tab to set event listeners for
       * @returns { void }
       */
    }, {
      key: "setTabEventListeners",
      value: function setTabEventListeners(tab) {
        var _this3 = this;
        var tabGroup = tab.closest('.dcf-tabs');
        tab.addEventListener('keydown', function (keydownEvent) {
          if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents('arrowLeft'))) {
            // We can switch to the tab
            var newTab = _this3.switchToPreviousTab(tabGroup);
            if (newTab === null) {
              return;
            }

            // If we get a tab back we can focus, prevent default, and update tht url hash
            newTab.focus();
            keydownEvent.preventDefault();
            _this3.updateURLHash(tabGroup);
          } else if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents('arrowRight'))) {
            // We can switch to the tab
            var _newTab = _this3.switchToNextTab(tabGroup);
            if (_newTab === null) {
              return;
            }

            // If we get a tab back we can focus, prevent default, and update tht url hash
            _newTab.focus();
            keydownEvent.preventDefault();
            _this3.updateURLHash(tabGroup);
          } else if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents('home'))) {
            // We can switch to the tab
            var _newTab2 = _this3.switchToFirstTab(tabGroup);
            if (_newTab2 === null) {
              return;
            }

            // If we get a tab back we can focus, prevent default, and update tht url hash
            _newTab2.focus();
            keydownEvent.preventDefault();
            _this3.updateURLHash(tabGroup);
          } else if (_dcfUtility.DCFUtility.isKeyEvent(keydownEvent, _dcfUtility.DCFUtility.keyEvents('end'))) {
            // We can switch to the tab
            var _newTab3 = _this3.switchToLastTab(tabGroup);
            if (_newTab3 === null) {
              return;
            }

            // If we get a tab back we can focus, prevent default, and update tht url hash
            _newTab3.focus();
            keydownEvent.preventDefault();
            _this3.updateURLHash(tabGroup);
          }
        });

        // If we click the tab we can switch to it
        tab.addEventListener('click', function (clickEvent) {
          _this3.switchTab(tab);
          _this3.updateURLHash(tabGroup);
          clickEvent.preventDefault();
        });

        // If the command comes in we can switch the tabs
        tab.addEventListener(DCFTabs.events('commandSwitch'), function () {
          _this3.switchTab(tab);
        });
      }

      /**
       * This function will switch to the next tab
       * @param {HTMLElement} tabGroup - TabGroup to be switched
       * @returns {HTMLElement | null}
       */
    }, {
      key: "switchToNextTab",
      value: function switchToNextTab(tabGroup) {
        // Gets the selected tab
        var selectedTab = tabGroup.querySelector('.dcf-tab[aria-selected="true"]');

        // Gets a list of the non hidden tabs
        var nonHiddenTabs = Array.from(selectedTab.closest('.dcf-tabs-list').querySelectorAll('.dcf-tab:not([hidden])'));

        // Find the index of the selected tab and if it hidden we can set it to 0
        var selectedTabIndex = nonHiddenTabs.findIndex(function (tab) {
          return tab.isEqualNode(selectedTab);
        });
        if (selectedTabIndex === _dcfUtility.DCFUtility.magicNumbers('intMinus1')) {
          selectedTabIndex = _dcfUtility.DCFUtility.magicNumbers('int0');
        }

        // We can then calculate and validate the next index
        var nextIndex = selectedTabIndex + _dcfUtility.DCFUtility.magicNumbers('int1');
        if (nextIndex >= nonHiddenTabs.length) {
          return null;
        }

        // If valid we can then switch the tab
        var newTab = nonHiddenTabs[nextIndex];
        this.switchTab(newTab);
        return newTab;
      }

      /**
       * This function will switch to the previous tab
       * @param {HTMLElement} tabGroup - TabGroup to be switched
       * @returns {HTMLElement | null}
       */
    }, {
      key: "switchToPreviousTab",
      value: function switchToPreviousTab(tabGroup) {
        // Gets the selected tab
        var selectedTab = tabGroup.querySelector('.dcf-tab[aria-selected="true"]');

        // Gets a list of the non hidden tabs
        var nonHiddenTabs = Array.from(selectedTab.closest('.dcf-tabs-list').querySelectorAll('.dcf-tab:not([hidden])'));

        // Find the index of the selected tab and if it hidden we can set it to 0
        var selectedTabIndex = nonHiddenTabs.findIndex(function (tab) {
          return tab.isEqualNode(selectedTab);
        });
        if (selectedTabIndex === _dcfUtility.DCFUtility.magicNumbers('intMinus1')) {
          selectedTabIndex = _dcfUtility.DCFUtility.magicNumbers('int0');
        }

        // We can then calculate and validate the next index
        var nextIndex = selectedTabIndex - _dcfUtility.DCFUtility.magicNumbers('int1');
        if (nextIndex < _dcfUtility.DCFUtility.magicNumbers('int0')) {
          return null;
        }

        // If valid we can then switch the tab
        var newTab = nonHiddenTabs[nextIndex];
        this.switchTab(newTab);
        return newTab;
      }

      /**
       * This function will switch to the first tab
       * @param {HTMLElement} tabGroup - TabGroup to be switched
       * @returns {HTMLElement | null}
       */
    }, {
      key: "switchToFirstTab",
      value: function switchToFirstTab(tabGroup) {
        // Gets the selected tab
        var selectedTab = tabGroup.querySelector('.dcf-tab[aria-selected="true"]');

        // Gets a list of the non hidden tabs
        var nonHiddenTabs = Array.from(selectedTab.closest('.dcf-tabs-list').querySelectorAll('.dcf-tab:not([hidden])'));

        // We then get the first item in the list and switch to it
        var newTab = nonHiddenTabs[_dcfUtility.DCFUtility.magicNumbers('int0')];
        this.switchTab(newTab);
        return newTab;
      }

      /**
       * This function will switch to the last tab
       * @param {HTMLElement} tabGroup - TabGroup to be switched
       * @returns {HTMLElement | null}
       */
    }, {
      key: "switchToLastTab",
      value: function switchToLastTab(tabGroup) {
        // Gets the selected tab
        var selectedTab = tabGroup.querySelector('.dcf-tab[aria-selected="true"]');

        // Gets a list of the non hidden tabs
        var nonHiddenTabs = Array.from(selectedTab.closest('.dcf-tabs-list').querySelectorAll('.dcf-tab:not([hidden])'));

        // We then get the last item in the list and switch to it
        var newTab = nonHiddenTabs[nonHiddenTabs.length - _dcfUtility.DCFUtility.magicNumbers('int1')];
        this.switchTab(newTab);
        return newTab;
      }

      /**
       * Switched tabs to new tab
       * @param {HTMLElement} newTab - Tab to switch to
       * @param {bool} AfterPageLoad - Whether the page has loaded yet
       * @returns { void }
       */
    }, {
      key: "switchTab",
      value: function switchTab(newTab) {
        var _this4 = this;
        var AfterPageLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        // Get and validate the tabGroup and List
        var tabGroup = newTab.closest('.dcf-tabs');
        var tabList = newTab.closest('.dcf-tabs-list');
        if (tabList === null || tabGroup === null) {
          throw new Error('Invalid Tab');
        }

        // Get and validate the currently selected tab and it is the new one as well we can just return
        var selectedTab = tabList.querySelector('.dcf-tab[aria-selected="true"]');
        if (selectedTab !== null && selectedTab.isEqualNode(newTab)) {
          return;
        }
        if (tabGroup.classList.contains('dcf-tabs-scroll') && AfterPageLoad) {
          newTab.scrollIntoView();
        }

        // We can then get a list of the tabs and loop through them
        var tabs = tabList.querySelectorAll('.dcf-tab');
        tabs.forEach(function (tab) {
          // We can then find the matching panel and validate it
          var matchingPanel = document.getElementById(tab.getAttribute('href').replace('#', ''));
          if (matchingPanel === null) {
            throw new Error('Invalid Tab href reference', {
              cause: tab
            });
          }

          // If the tab we are on is the new one we can select it
          if (tab.isEqualNode(newTab)) {
            tab.setAttribute('tabindex', '0');
            tab.setAttribute('aria-selected', true);
            matchingPanel.removeAttribute('hidden');

            // If we have url tracking enabled we can update the url tabs param
            if (tabGroup.dataset.urlTracking === 'true' && AfterPageLoad) {
              _this4.updateURLParam(tabGroup);
            }
          } else {
            // Otherwise we will hide the tab and panel
            tab.setAttribute('tabindex', '-1');
            tab.removeAttribute('aria-selected');
            matchingPanel.setAttribute('hidden', '');
          }
        });

        // We can then dispatch and event that the tab has switched
        tabGroup.dispatchEvent(this.tabSwitchedEvent);
      }
    }], [{
      key: "events",
      value: function events(name) {
        var events = {
          tabsReady: 'ready',
          tabSwitched: 'tabSwitched',
          commandSwitch: 'commandSwitch',
          commandPrev: 'commandPrev',
          commandNext: 'commandNext',
          commandHome: 'commandHome',
          commandEnd: 'commandEnd'
        };
        Object.freeze(events);
        return name in events ? events[name] : undefined;
      }
    }]);
    return DCFTabs;
  }();
  _exports.DCFTabs = DCFTabs;
});

